<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <h3 align="left">Procedimientos:</h3>
      </v-col>
    </v-row>
    <v-row v-if="!isViewDetailsForm">
      <v-col cols="6" sm="12" md="6" lg="6">
        <v-autocomplete
          v-model="selectProcedure.procedure"
          :items="listProcedures"
          :disabled="isViewDetailsForm"
          label="Procedimiento"
          item-text="name"
          return-object
          @input="onInput('procedure')"
          no-data-text="Sin resultados disponibles"
          clearable
          :clear-icon="$cnst.CLEAR_ICON"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="6" sm="12" md="6" lg="6">
        <v-autocomplete
          v-model="selectProcedure.bodyPart"
          :items="listSide"
          :disabled="isViewDetailsForm"
          label="Posición"
          item-text="acronym"
          return-object
          no-data-text="Sin resultados disponibles"
          @input="onInput('position')"
          clearable
          :clear-icon="$cnst.CLEAR_ICON"
        ></v-autocomplete>
      </v-col>
      <v-col cols="9" sm="12" md="9" lg="9">
        <v-autocomplete
          v-model="selectProcedure.bodyElements"
          :items="listBodyElements"
          label="Zona ocular"
          :disabled="isViewDetailsForm"
          item-text="name"
          no-data-text="Sin resultados disponibles"
          multiple
          chips
          deletable-chips
          return-object
          @input="onInput('zone')"
          clearable
          :clear-icon="$cnst.CLEAR_ICON"
        ></v-autocomplete>
      </v-col>
      <v-col cols="3" sm="12" md="3" lg="3" class="text-center">
        <v-btn
          :disabled="!fillButton"
          color="#59805c"
          @click="addProcedure()"
          class="white--text"
        >
          <v-icon color="white">mdi-plus</v-icon>Agregar</v-btn
        >
      </v-col>
    </v-row>

    <v-row
      v-if="model.procedures != null || listProceduresOptometry.length > 0"
    >
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-data-table
          :headers="headers"
          :items="listProceduresOptometry"
          height="auto"
          class="elevation-1"
          no-data-text="Sin resultados disponibles"
          fixed-header
          :footer-props="{
            'items-per-page-text': 'Elementos por página',
            'items-per-page-all-text': 'Todo',
            'items-per-page-options': [10],
          }"
        >
          <template v-slot:[`item.actions`]="{ index }">
            <v-tooltip v-if="isDelete" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="error"
                  class="mr-2"
                  @click="deleteProcedure(index)"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="isViewDetailsForm"
                >
                  mdi mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.guide`]="{ index }">
            <div>
              {{ index + 1 }}
            </div>
          </template>
          <template v-slot:[`item.bodyElements`]="{ value }">
            <div>
              {{ value.map((obj) => obj.name).join(", ") }}
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { OptometryComponentService } from "@/app/services";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  props: {
    model: Object,
    isViewDetailsForm: Boolean,
    toUpdateTable: Boolean,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      listProceduresOptometry: [],
      isDelete: true,
      headers: [
        { text: "#", value: "guide" },
        { text: "Procedimiento", value: "procedure.name" },
        { text: "Posición", value: "bodyPart.acronym" },
        { text: "Zonas oculares", value: "bodyElements" },
        { text: "Acciones", value: "actions", sortable: false, width: "10%" },
      ],
      listProcedures: [],
      listBodyElements: [],
      listSide: [],
      selectProcedure: {
        bodyElements: null,
        procedure: null,
        bodyPart: null,
      },
      fillButton: false,
      zoneVal: false,
      procedureVal: false,
      positionVal: false,
    };
  },
  mounted() {
    this.listAll();
    if (this.toUpdateTable) {
      this.checksaveProcedures();
    }
  },

  methods: {
    onInput(field) {
      switch (field) {
        case "zone":
          this.zoneVal = this.selectProcedure.bodyElements.length !== 0;
          break;
        case "procedure":
          this.procedureVal = this.selectProcedure.procedure !== null;
          break;
        case "position":
          this.positionVal = this.selectProcedure.bodyPart !== null;
          break;
      }
      this.fillButton = this.zoneVal && this.procedureVal && this.positionVal;
    },
    addProcedure() {
      this.listProceduresOptometry.push(this.selectProcedure);
      this.model.procedures = this.listProceduresOptometry;
      this.selectProcedure = {
        bodyElements: null,
        procedure: null,
        bodyPart: null,
      };
      this.zoneVal = false;
      this.procedureVal = false;
      this.positionVal = false;
      this.fillButton = false;
    },
    deleteProcedure(index) {
      this.listProceduresOptometry.splice(index, 1);
      this.model.procedures = this.listProceduresOptometry;
    },
    listAll() {
      OptometryComponentService.optometryProcedures().then((res) => {
        this.listProcedures = res.data;
      });
      OptometryComponentService.optometryZones().then((res) => {
        res.data.map((bodypart) => {
          let body = {
            idBodyElement: bodypart.idBodyElement,
            name: bodypart.name,
          };
          this.listBodyElements.push(body);
        });
      });
      OptometryComponentService.optometrySide().then((res) => {
        this.listSide = res.data;
      });
    },
    checksaveProcedures() {
      this.listProceduresOptometry = this.model.procedures;
    },
  },
};
</script>

<style></style>
